/**
 * One organization's custom fields for the signed-in musician, as served by
 * GET local420/members/me/customFields.
 *
 * A field is an org-defined NoteType whose effective visibility for this
 * musician is "editable" — hidden fields never reach this app. The value is
 * the musician's MusicianNote for that field (may be unset).
 */
export default class CustomFieldGroup_Entity {
  static requiredFields = ["organization", "musicianID", "fields"];

  constructor(customFieldGroupJson: CustomFieldGroup_Entity) {
    try {
      this.organization = customFieldGroupJson.organization;
      this.musicianID = customFieldGroupJson.musicianID;
      this.fields = customFieldGroupJson.fields ?? [];
    } catch (e) {
      throw new Error(
        "Failed to create new instance of ${ CustomFieldGroup_Entity.name }: ${e}"
      );
    }
  }

  organization: CustomFieldOrganization;
  musicianID: number;
  fields: CustomField[];
}

export type CustomFieldOrganization = {
  id: number;
  name?: string;
  logo?: string;
};

export type CustomField = {
  noteTypeID: number;
  name?: string;
  /**
   * textfield | phone | date | time | dateRange | color | boolean | rating
   * | select — same kind strings the Studio admin app stores.
   */
  kind?: string;
  /** Kind payload; for select: comma-separated option list. */
  data?: string;
  musicianNoteID?: number;
  value?: string;
};
